/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Free_7Inputs */



/**
* | output |
* | --- |
* | "Desktop installer and browser-based editor" |
*
* @param {Signup_Feature_Free_7Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_free_7 = /** @type {((inputs?: Signup_Feature_Free_7Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Free_7Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Desktop installer and browser-based editor")
	if (locale === "de") return /** @type {LocalizedString} */ ("Desktop installer and browser-based editor")
	if (locale === "it") return /** @type {LocalizedString} */ ("Desktop installer and browser-based editor")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Desktop installer and browser-based editor")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desktop installer and browser-based editor")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Desktop installer and browser-based editor")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Desktop installer and browser-based editor")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Desktop installer and browser-based editor")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desktop installer and browser-based editor")
	return /** @type {LocalizedString} */ ("Desktop installer and browser-based editor")
});